module.exports = __webpack_public_path__ + "img/nf1图标-1.f4e1a49e.png";